import { Button } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineTrash } from 'react-icons/hi';
import Popup from 'reactjs-popup';

interface DeleteConfirmationPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmationPopup: FC<DeleteConfirmationPopupProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Popup
      overlayStyle={{ background: 'rgba(100, 100, 100, 0.35)' }}
      contentStyle={{
        backgroundColor: '#fbfcfd',
        borderRadius: '10px',
        width: '80%',
        maxWidth: '400px',
      }}
      modal
      open={isOpen}
      onClose={onClose}
    >
      <div className="flex flex-col flex-nowrap gap-y-4 p-4">
        <div className="flex flex-row justify-between items-start">
          <h2 className="font-bold text-xl text-day-neutral-dark">
            {t('project-management.delete-confirmation')}
          </h2>
          <HiOutlineTrash className="w-6 h-6" onClick={onClose} />
        </div>
        <p className="text-day-neutral-subtle">
          {t('project-management.delete-confirmation-message')}
        </p>
        <div className="flex gap-4 mt-2">
          <Button className="w-full" secondary rounded onClick={onClose}>
            {t('project-management.cancel')}
          </Button>
          <Button className="w-full" primary rounded onClick={onConfirm}>
            {t('project-management.delete')}
          </Button>
        </div>
      </div>
    </Popup>
  );
};
